import {
	IsIn,
	IsNotEmpty,
	IsOptional,
	Validate,
	ValidatorConstraint,
	ValidatorConstraintInterface,
	ValidationArguments
} from "class-validator";
import {BaechaType, BaechaWorkDayType, CarType, PriceReceiveMethodEnum, PriceType} from "../../../../types/Type";

@ValidatorConstraint({ name: "eitherOr", async: false })
class EitherOrConstraint implements ValidatorConstraintInterface {
	validate(value: any, args: ValidationArguments) {
		const object = args.object as any;
		return !!object.workHour || !!object.workDay;
	}

	defaultMessage(args: ValidationArguments) {
		return "Either workHour or workDay must be provided!";
	}
}

export default class BaljuDTO {
	// ============================ required ============================
	@IsNotEmpty()
	baljuGroupId: string;

	@IsNotEmpty()
	baljuingGroupId: string;

	@IsNotEmpty()
	@IsIn(['1t', '2t', '3t', '1-2t', '2-3t', '1-3t', '5t', '54m', '58m', '75m', '54m_over', '58m_over', '28m', '40m', '60m', '70m'])
	carType: CarType;

	@IsNotEmpty()
	workLoc: string;

	@IsNotEmpty()
	workArriveDate: any;

	@IsNotEmpty()
	price: number;

	@IsNotEmpty()
	@IsIn(['direct_ad', 'direct_noad', 'sign'])
	priceReceiveMethod: PriceReceiveMethodEnum;

	@IsNotEmpty()
	@IsIn(['rollcall', 'normal', 'urgent', 'designated'])
	baechaType: BaechaType;

	@IsNotEmpty()
	baljuMemberId: string;

	@IsNotEmpty()
	baljuMemberCarId: string;

	// ============================ optional ============================

	@IsOptional()
	workHour?: number;

	@IsIn([1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31])
	@IsOptional()
	workDay?: BaechaWorkDayType;

	@Validate(EitherOrConstraint)
	validateWorkHourOrDay?: boolean; // workHour와 workDay 중 하나는 필수로 있어야 함. 이걸 확인하는 용도임.

	isWorkMonth?: boolean;

	isNoFee?: boolean;

	workContent?: string;

	workEtc?: string;

	designatedMemberId?: string;

	@IsOptional()
	priceType?: PriceType; // 서버에서 계산해서 넣어주는 값

	@IsOptional()
	isLink?: boolean;

	@IsOptional()
	carDetail?: string;

	@IsOptional()
	isSpecificCarOnly?: boolean;

	@IsOptional()
	privateAddress?: string;

	@IsOptional()
	privatePhone?: string;

	@IsOptional()
	privateNote?: string;

	@IsOptional()
	longitude?: number;

	@IsOptional()
	latitude?: number;

	@IsOptional()
	region?: string;

	constructor(values: {
		baljuGroupId: string,
		baljuingGroupId: string,
		carType: CarType,
		workLoc: string,
		workArriveDate: any,
		price: number,
		priceReceiveMethod: PriceReceiveMethodEnum,
		baechaType: BaechaType,
		baljuMemberId: string,
		baljuMemberCarId: string,
		workHour?: number,
		workDay?: BaechaWorkDayType,
		isWorkMonth?: boolean,
		isNoFee?: boolean,
		workContent?: string,
		workEtc?: string,
		designatedMemberId?: string,
		priceType?: PriceType,
		isLink?: boolean,
		carDetail?: string,
		isSpecificCarOnly?: boolean,
		privateAddress?: string,
		privatePhone?: string,
		privateNote?: string,
		longitude?: number,
		latitude?: number,
		region?: string,
	}) {
		this.baljuGroupId = values.baljuGroupId;
		this.baljuingGroupId = values.baljuingGroupId;
		this.carType = values.carType;
		this.workLoc = values.workLoc;
		this.workArriveDate = values.workArriveDate;
		this.price = values.price;
		this.priceReceiveMethod = values.priceReceiveMethod;
		this.baechaType = values.baechaType;
		this.baljuMemberId = values.baljuMemberId;
		this.baljuMemberCarId = values.baljuMemberCarId;
		this.workHour = values.workHour;
		this.workDay = values.isWorkMonth ? 30 : values.workDay;
		this.isWorkMonth = values.isWorkMonth || false;
		this.isNoFee = values.isNoFee || false;
		this.workContent = values.workContent;
		this.workEtc = values.workEtc;
		this.designatedMemberId = values.designatedMemberId;
		this.validateWorkHourOrDay = true;
		this.priceType = values.priceType;
		this.isLink = values.isLink;
		this.carDetail = values.carDetail;
		this.isSpecificCarOnly = values.isSpecificCarOnly || false;
		this.privateAddress = values.privateAddress;
		this.privatePhone = values.privatePhone;
		this.privateNote = values.privateNote;
		this.longitude = values.longitude;
		this.latitude = values.latitude;
		this.region = values.region;
	}
}